import React, { useEffect, useState, useRef } from "react";
import { AiOutlineEnvironment } from "react-icons/ai";
import { FiSearch } from "react-icons/fi";
import "./SearchBar.css";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import dayjs from "dayjs";
import { DatePicker } from "antd";
// import LocationList from './Locations';
import axios from "../../Utilities/axios";
import { Blocks } from "react-loader-spinner";
import AOS from "aos";
import "aos/dist/aos.css";
// import SpinnerPage from './SpinnerPage';
// import { ThreeDots } from  'react-loader-spinner'

const SearchForm = () => {
  // const [showDrop, setShowDrop] = useState(false);
  const [value, setValue] = useState("");
  const [dates, setDates] = useState([]);
  // const [hotelId, setHotelId] = useState()
  const [searchResultChange, setSearchResultChange] = useState();
  // const [isLoading2, setIsLoading2] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState("");
  const [selectedHotelObj, setSelectedHotelObj] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigation = useNavigate();

  const { RangePicker } = DatePicker;
  const dateFormat = "YYYY-MM-DD :HH:mm";
  const defDate = new Date();
  let defDate2 = moment(defDate).format("YYYY-MM-DD :HH:mm");
  let locationList1 = useRef();

  const today = new Date();
  let tomorrow = new Date();
  let tom = moment(tomorrow.setDate(today.getDate() + 1)).format(
    "YYYY-MM-DD : HH:mm",
  );

  const joinDates = [defDate2, tom];

  useEffect(() => {
    setDates(joinDates);
  }, []);

  const onChange = (value, dateString) => {
    console.log("Selected Time: ", value);
    console.log("Formatted Selected Time: ", dateString);
  };

  const onOk = (value) => {
    console.log("onOk: ", value);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        locationList1.current &&
        !locationList1.current.contains(event.target)
      ) {
        locationList1.current.style.display = "none";
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.addEventListener("click", handleClickOutside);
    };
  }, [locationList1]);

  // const onSearch = (searchTerm, searchHotelId) => {
  //   setValue(searchTerm);
  //   setHotelId(searchHotelId);
  // };

  const handleHotelChange = (event) => {
    const hotelName = event.target.value;
    setSelectedHotel(hotelName);
    setValue(hotelName);
    const hotelObj = searchResultChange?.find(h => h.hotelName === hotelName);
    setSelectedHotelObj(hotelObj || null);
  };

  useEffect(() => {
    const getHotel = async (event) => {
      const onChangeSearch = await axios.get(
        `/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`,
      );

      const searchResult = onChangeSearch.data;

      setSearchResultChange(searchResult);
      // setValue(searchResult);
    };
    getHotel();
  }, []);

  // const getHotelsLocation = async (event) => {
  //   setValue(event.target.value);
  //   // setShowDrop(true);
  //   // setIsLoading2(true);
  //   setSelectedHotel(" ")

  //   if (event.target.value.length > 0) {
  //     setValue(event.target.value);
  //   } else {
  //     setValue("");
  //   }

  //   // if (event.target.value === "") {
  //   //   setShowDrop(false);
  //   // }

  //   const onChangeSearch = await axios.get(`/registrations/hotels?genFilter=${selectedHotel}&sourceType=showInCompanySite&hotelGroupName=Residency`);

  //   const searchResult = onChangeSearch.data;

  //   setSearchResultChange(searchResult);
  //   // setIsLoading2(false);

  // };

  const searchForHotel = async (event) => {
    event.preventDefault();
    if (!selectedHotelObj) return;

    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let randomCode = "";
    for (let i = 0; i < 20; i++) {
      randomCode += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    const hotelSlug = selectedHotelObj.hotelName.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

    navigation(`/hotel-rooms/${hotelSlug}/${selectedHotelObj.hotelId}/${randomCode}`, {
      state: { hotel: selectedHotelObj, dates },
    });
  };

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div
      className="searchBar"
      style={{
        background: "linear-gradient(135deg, #2E2D90 0%, #4b49c4 100%)",
        borderRadius: "20px",
        boxShadow: "0 24px 60px rgba(46, 45, 144, 0.35)",
        padding: "20px",
      }}
    >
      <form className="row justify-content-center">
        <div className="col-md-5 formSelect ">
          {/* <input
            type="text"
            className="form-control mb-2"
            id="inlineFormInput"
            placeholder="Destination"
            handleShow={handleShow}
            value={value}
            onSearch={onSearch}
            onChange={getHotelsLocation}     
          />
          {showDrop && (
            <div ref={locationList1} className="locationHandler">
              <LocationList
                onSearch={onSearch}
                value={value}
                availableHotel={searchResultChange}
                handleShow={handleShow}
              />
            </div>
          )} */}

          <div className="field-with-icon">
            <AiOutlineEnvironment className="field-icon" />
            <select
              className="form-select form-select-lg mb-2"
              // onClick={getHotelsLocation}
              style={{ fontSize: "1em", height: "55px" }}
              value={selectedHotel}
              onChange={handleHotelChange}
            >
              <option disabled value="" selected style={{ fontSize: "1em" }}>
                Select Destination
              </option>

              {searchResultChange &&
                searchResultChange.map((hotel, i) => (
                  <option
                    value={hotel.hotelName}
                    key={hotel.hotelId}
                    style={{ fontSize: "1em" }}
                  >
                    {hotel.hotelName}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="col-md-5 formSelect">
          {/* <label className="sr-only" for="inlineFormInputGroup">
                    Username
                  </label> */}
          <div className="input-group mb-2">
            <RangePicker
              allowClear={false}
              defaultValue={[
                dayjs(defDate2, dateFormat),
                dayjs(tom, dateFormat),
              ]}
              disabledDate={(current) => {
                let customDate = moment().format("YYYY-MM-DD:HH:mm");
                return (
                  current && current < moment(customDate, "YYYY-MM-DD : HH:mm")
                );
              }}
              format="YYYY-MM-DD HH:mm"
              onChange={onChange}
              onOk={onOk}
              id="inlineFormInputGroup"
              className=" form-control2"
            />
          </div>
        </div>

        <div className="col-md-2 formSelect2">
          {isLoading ? (
            <button className="btn btn-primary">
              <Blocks
                visible={true}
                height="30"
                width="100"
                ariaLabel="blocks-loading"
                wrapperStyle={{}}
                wrapperclassName="blocks-wrapper"
              />
            </button>
          ) : (
            <button
              className="btn btn-primary"
              onClick={(e) => searchForHotel(e)}
              disabled={value === "" ? true : false}
            >
              <FiSearch aria-hidden="true" />
              Search Hotels
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default SearchForm;
